import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pass-key-delete-failure',
  templateUrl: './pass-key-delete-failure.component.html',
  styleUrl: './pass-key-delete-failure.component.scss',
  standalone: false
})
export class PassKeyDeleteFailureComponent implements OnInit {

  onCloseLinkSubmit: () => void;

  constructor(private readonly translate: TranslateService) { }

  ngOnInit(): void {
  }

  onCloseClick(){
    this.onCloseLinkSubmit();
  }

}
